/* eslint-disable import/no-unused-modules */
import React from 'react';
import AuthorProfile from '../../components/Profile/AuthorProfile';
import Profile from '../../components/Profile/Profile';
import { GET_PROFILE } from '../../helpers/graphql/profile';
import graphQLClient from '../../helpers/graphQLClient';
import withApollo from '../../lib/withApollo';

const BlogPage = ({ profile, username }) => {
  return (
    <>
      <AuthorProfile profile={profile} username={username} />
      {profile && <Profile profile={profile} />}
    </>
  );
};

export async function getStaticProps({ params }) {
  if (!params.author || params.author[0] !== '@')
    return { notFound: true, revalidate: 10 };
  const username = params.author.replace(/@/, '');

  try {
    const fetchProfile = await graphQLClient(GET_PROFILE, {
      username,
    });
    if (!fetchProfile || !fetchProfile.profile || !fetchProfile.profile.author)
      return { notFound: true, revalidate: 10 };
    return {
      props: { profile: fetchProfile.profile, username },
      revalidate: 10,
    };
  } catch {
    return { notFound: true, revalidate: 10 };
  }
}

export async function getStaticPaths() {
  return { paths: [], fallback: 'blocking' };
}

export default withApollo(BlogPage);
